import queryClient, { IQueryParams } from 'queries';
import helpers from 'helpers/index';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TypedUser } from 'interface/user.model';
import { TypedOrders } from './orders.query';
import { TypedVehicle } from './vehicle.query';
import { TypedInvoices } from './invoices.query';

/** Công nợ hay không? Default là mặc định, không công nợ ... */
export enum ENUM_TRANSACTION_PAYMENT_METHOD {
    CASH = 'CASH',
    BANK = 'BANK',
    DEBT_CUSTOMER = 'DEBT_CUSTOMER',
    DEBT_AGENT = 'DEBT_AGENT',
    THIRD_PARTY = 'THIRD_PARTY',
}



export interface TypedTransactions {
    id?: string;
    order_id?: string;
    order_code?: string; /** String index để khi sync bên kia sang thì đối chiếu cho nó nhanh ... vì lúc ấy chưa có order_id */
    amount?: number;
    payment_method?: ENUM_TRANSACTION_PAYMENT_METHOD;
    description?: string;
    note?: string;
    lastError?: string;
    casher?: string;
    driver_id?: string;
    vehicle_id?: string;
    invoice_id?: string;
    createdAt?: string;
    timestamp?: string; /** thời gian của ngân hàng, kệ nó */

    casher_data?: TypedUser;
    order_data?: TypedOrders;


    debt_cleared_by?: string;
    debt_cleared_at?: string;
    debt_clear_note?: string;

    vehicle_data?: TypedVehicle;
    driver_data?: TypedUser;
    invoice_data?: TypedInvoices;
    debt_clearer?: TypedUser;
}


export interface TypedTransactions_callback {
    id?: string;
    amount?: number;
    content?: string;
    note?: string;
    order_code?: string;
    invoice_number?: number;
    timestamp?: string;
    createdAt?: string;
}

export interface TypedTransactionAnalytics {
    "count": { "CASH": number, "BANK": number, DEBT_CUSTOMER: number, DEBT_AGENT: number, THIRD_PARTY: number }, "sum": { "CASH": number, "BANK": number, DEBT_CUSTOMER: number, DEBT_AGENT: number, THIRD_PARTY: number }, "sum_unsigned": { amount: number, count: number }
}

type IQuery = TypedTransactions & IQueryParams;
type IQuery2 = TypedTransactions_callback & IQueryParams;

/*
* List of all transactions
*/

export function useGetTransactions(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["transactions/fetch_entity_list", object],
        queryFn: () => axios.get<{
            transactions: TypedTransactions[];
            analytics: TypedTransactionAnalytics;
            totalItems: number;
        }>(`/transactions/${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                transactions: data.transactions,
                analytics: data.analytics,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
    });
}
export function useGetTransaction(transaction_id: any) {
    return useQuery({
        queryKey: ["transactions/fetch_entity", transaction_id],
        queryFn: () => axios.get<TypedTransactions>(`/transactions/${transaction_id}`).then(response => response.data),
        retry: 1,
        enabled: !!transaction_id
    });
}

/** Tải về excel bản đang xem */
export function useDownloadTransactions() {
    return useMutation({
        mutationKey: ["transactions/download"],
        mutationFn: (object: IQuery) => axios.get<Blob>(`/transactions/download/${helpers.buildEndUrl(object)}`, { responseType: 'blob', }).then(response => response.data),
    })
}


/** Gạt nợ công nợ */
export function useMutateRemoveDebitClearing() {
    return useMutation({
        mutationKey: ["transactions/debt_cleared"],
        mutationFn: ({ debt_clear_note, payment_method, transaction_id }: { debt_clear_note: string, payment_method: string, transaction_id: any[] }) => axios.post<any>(`/transactions/debt_cleared/`, { debt_clear_note, payment_method, transaction_id }).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['transactions/fetch_entity_list'] });
        }
    });
}


export function useMutateUpdateTransaction() {
    return useMutation({
        mutationKey: ["transactions/update_entity"],
        mutationFn: ({ id, ...__object }: TypedTransactions) => axios.patch<TypedTransactions>(`/transactions/${id}`, __object).then(response => response.data),
        retry: 1,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['transactions/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['transactions/fetch_entity'] });
        }
    });
}


/*
* List of all transactions
*/
export function useGetTransactionsCallback(object: IQuery2) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["transactions_callback/fetch_entity_list", object],
        queryFn: () => axios.get<TypedTransactions_callback[]>(`/transactions_callback/${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                entities: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
    });
}

/** Xét lại một giao dịch để nó bắt đúng đơn hàng và mã hóa đơn, móa ... */
export function useMutateReloadTransactions() {
    return useMutation({
        mutationKey: ["transactions/reload"],
        mutationFn: (transactions_id) => axios.get<TypedTransactions>(`/transactions/reload/${transactions_id}`).then(response => response.data),
        retry: 1,
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['transactions/fetch_entity_list'] });
        }
    });
}

/** Xóa một transactions ... */
export function useMutateDeleteTransactions() {
    return useMutation({
        mutationKey: ["transactions/delete_entity"],
        mutationFn: (transactions_id) => axios.delete<any>(`/transactions/${transactions_id}`).then(response => response.data),
        retry: 1,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['transactions/fetch_entity_list'] });
        }
    });
}

/**
 * 
 * ABC DEF
 */

export function useImportTransactions() {
    return useMutation({
        mutationKey: ['transactions/import'],
        mutationFn: (entity: { media_id: string }) => axios.post<{
            total: number;
            total_error: number,
            total_success: number,

        }>(`/transactions/import`, helpers.cleanEntity(entity)).then((response) => response.data),
    });
}



